import {Component, OnInit, ViewEncapsulation, Input, Pipe, PipeTransform, Output, EventEmitter, ViewChild, ElementRef} from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith, debounceTime} from 'rxjs/operators';
import { CommonService } from '../../services/common.service';
import { MatFormField, MatInput } from '@angular/material/input';
import { NumberOnlyDirective } from '../../directives/num-only.directive';


@Component({
    selector: 'app-auto-completesearch',
    templateUrl: './auto-complete.component.html',
    styleUrls: ['./auto-complete.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [ReactiveFormsModule, MatFormField, MatInput, NumberOnlyDirective]
})
export class AutocompletesearchComponent implements OnInit {
  @Input() searchdataInput: any;
  @Input() searchFullData: any;
  @Input() searchoptionalParams: any;
  @Input() checkOnlineStatusforSearch = true;
  @Output() returnData = new EventEmitter<any>();
  @Output() ApiSearchData = new EventEmitter<any>();
  @Output() clearSearch = new EventEmitter<any>();
  @Output() emitOffineNoDataforSearch = new EventEmitter<any>();
  @Output() callFocusOut = new EventEmitter<any>();
  @Output() callFocusIn = new EventEmitter<any>();
  @Output() searchApplied = new EventEmitter<any>();
  @ViewChild('dataInput') dataInput: ElementRef;

  public doSearch = true;
  public onlineSearch = false;
  public SearchApplied = false;
  public cancelIcon = false;
  public searchValue: any;
  public autoForm: any;

  constructor(private fb: FormBuilder,
    private _commonService: CommonService) {

  }
  /**
   * @function _filter(event: any)
   * @param String or number
   * @description filter component search the array with particular key
   * @output Array: any
   */
   _filter(data) {
  //  _filter(event: any,data){
     if (this.checkOnlineStatusforSearch !== false) {
       const filterValue = data.toString().toLowerCase();
       ( filterValue.toString() === '' ) ? this.cancelIcon = false :  this.cancelIcon = true;
        // const filterValue = event.target.value.toString().toLowerCase();
      if (!this.onlineSearch) {
        if (this.doSearch) {
          const valued = this.searchdataInput.filter(option => {
            const loopParam = this.searchoptionalParams.searchParam.some(param => {
              return option[param].toString().toLowerCase().includes(filterValue);
            });
            return loopParam;
          });
          this.returnData.emit(valued);
        } else {
          this.returnData.emit(filterValue);
        }
      } else {
        this._commonService.searchValue = filterValue;
        this.ApiSearchData.emit(filterValue);
      }
    } else {
      this.emitOffineNoDataforSearch.emit();
    }
    // if(this.searchoptionalParams.searchParam == 'id'){
    //   const filterValue = event.target.value;
    //   ( filterValue == "" ) ? this.cancelIcon = false :  this.cancelIcon = true;
    //   let valued = this.searchdataInput.filter(option => option.id.toString().toLowerCase().includes(filterValue) );
    //   this.returnData.emit(valued)
    // }else{
    //   const filterValue = event.target.value.toLowerCase();
    //   ( filterValue.toString() == "" ) ? this.cancelIcon = false :  this.cancelIcon = true;
    //   let valued = this.searchdataInput.filter(option => option.name.toLowerCase().includes(filterValue));
    //   this.returnData.emit(valued)
    // }
    this.searchApplied.emit(this.cancelIcon);
  }

    /**
   * @function clearText()
   * @param none
   * @description Click the cancel icon clear the input text
   * @output none
   */

  clearText(frombuttonClick = false) {
    if (this.searchoptionalParams.onlineSearch && this.searchoptionalParams.onlineSearch === true) {
      if ((this.searchoptionalParams.SearchApplied || this._commonService.searchValue) && frombuttonClick) {
        this.dataInput.nativeElement.value = '';
        this.cancelIcon = false;
        this._commonService.searchValue = '';
        /* setTimeout(() => {
          this.dataInput.nativeElement.focus();
        }, 0); */
        this.clearSearch.emit();
      }
    } else {
      this.dataInput.nativeElement.value = '';
      this.cancelIcon = false;
      this._commonService.searchValue = '';
      /* setTimeout(() => {
        this.dataInput.nativeElement.focus();
      }, 0); */
      this.clearSearch.emit();
    }
    this.searchApplied.emit(this.cancelIcon)
  }

  ngOnInit() {

    this.doSearch = this.searchoptionalParams.doSearch !== undefined ? this.searchoptionalParams.doSearch : true;
    this.onlineSearch = this.searchoptionalParams.onlineSearch !== undefined ? this.searchoptionalParams.onlineSearch : false;
    this.SearchApplied = this.searchoptionalParams.SearchApplied !== undefined ? this.searchoptionalParams.SearchApplied : false;
    if (!this.SearchApplied) {
      this.autoForm = this.fb.group({
        inputText: '',
      });
    } else {
      this.autoForm = this.fb.group({
        inputText: this._commonService.searchValue,
      });
    }
    const that = this;
    this.autoForm.valueChanges.pipe(debounceTime(500)).subscribe((data) => {
      that._filter(data.inputText);
    });
  }

  callFO() {
    this.callFocusOut.emit();
  }
  callFI() {
    this.callFocusIn.emit();
  }

}
